import React, { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { loadUser, logout } from "../Redux/actions/user";
import AppContainer from "../Components/AppContainer";
import keycloak from "../keycloak.js";
import NavBar from "./navbar";
import "./index.css";
import events from 'events';

function MainAppContainer(props) {

    let { loadUser, history } = props;
    window.EventEmitter = new events.EventEmitter(); 

    useEffect(() => {        
        async function keycloakInit() {
            let authenticated = await keycloak.init({ promiseType: "native" });
            if (authenticated) {
                loadUser();
            } else {
                if (history.location.pathname.includes("/try/signup") && history.location.search !== "") {
                    history.push(`/try/signup${history.location.search}`)     
                } 
                else {
                    keycloak.login();
                }
            }
        }
        keycloakInit();
    }, [loadUser, history]);



    if (props.user.email) {
        return (
            <div className="main-app">
                <NavBar {...props} />
                <div className="app-container">
                    <Switch>
                        <Route path="/" component={AppContainer} />
                    </Switch>
                </div>
            </div>
        )
    } else {
        return null
    }
}

const mapStateToProps = (state) => ({
    user: state.user
})

const mapDispatchToProps = dispatch => ({
    loadUser: bindActionCreators(loadUser, dispatch),
    logout: bindActionCreators(logout, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(MainAppContainer);